import { render, staticRenderFns } from "./title.vue?vue&type=template&id=1814cc1a&scoped=true&"
var script = {}
import style0 from "./title.vue?vue&type=style&index=0&id=1814cc1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1814cc1a",
  null
  
)

export default component.exports